<template>
  <Dialog
    :open="showDialog(Dialogs.QuizModal)"
    @update:open="onOpenChange"
  >
    <DialogScrollContent class="max-w-[740px]">
      <div class="rounded-md overflow-hidden">
        <iframe
          class="quizIframe w-full min-h-[420px] md:min-h-[550px] border-0"
          src="https://content.leadquizzes.com/lp/71eeFupQvQ?embed=1"
          title="Quiz"
        />
      </div>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogScrollContent,
} from "~/shared/components/ui/dialog";
import { Dialogs, useDialogsStore } from "~/stores/dialogStore";

const { showDialog, closeDialog } = useDialogsStore();

function onOpenChange(open: boolean) {
  if (!open) closeDialog(Dialogs.QuizModal);
}
</script>
